import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const ManageMembersComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "ManageMembersPage" */ "@circle-react/components/SettingsApp/ManageMembers"
    ),
);

export const ManageMembersPage = () => (
  <Suspense fallback={<PageLoader />}>
    <ManageMembersComponent />
  </Suspense>
);
